// Cookie-consent state, stored in localStorage. Analytics only load once the
// visitor has explicitly granted consent (PECR/GDPR).
const KEY = "cli_cookie_consent";

export function getConsent() {
  try {
    return localStorage.getItem(KEY); // "granted" | "denied" | null
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent("cli-consent", { detail: value }));
  } catch {
    /* ignore */
  }
}
